module.exports = __webpack_public_path__ + "bill-legal.06fc6f5ba466.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/marketing/icons/bill-legal.png
// module id = ./src/app/marketing/icons/bill-legal.png
// module chunks = 21